"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HardcutOutcome = void 0;
/** @TranslateToPython */
var HardcutOutcome;
(function (HardcutOutcome) {
    /** The hardcut is applicable and passed. */
    HardcutOutcome["PASS"] = "PASS";
    /** The hardcut is applicable and failed. */
    HardcutOutcome["FAIL"] = "FAIL";
    /**
     * The hardcut does not apply in this underwriting mode and must not fail the applicant, e.g. a
     * CoreLogic-based hardcut during experianOnly underwriting.
     */
    HardcutOutcome["NOT_APPLICABLE"] = "NOT_APPLICABLE";
})(HardcutOutcome || (exports.HardcutOutcome = HardcutOutcome = {}));
